import useBrowserMode from '../shared/hooks/useBrowserMode';

export const changeRef = (redireccion): string => {
    const { window } = useBrowserMode();
    let hostname = '/portal-servicios/';
    try {
        hostname =
            window?.location?.hostname === 'localhost'
                ? '/'
                : '/portal-servicios/';
    } catch (error) {
        console.error(error);
    }
    redireccion = redireccion ?? '/';
    if (
        redireccion?.includes('https') ||
        redireccion?.includes('http') ||
        redireccion?.includes('www')
    ) {
        return redireccion;
    } else {
        const paths = redireccion?.split('/');
        if (
            paths &&
            (paths[0].includes('portal-servicios') || paths[0] === '')
        ) {
            paths.shift();
        }
        // console.log("changeRef", redireccion, paths)
        return paths ? `${hostname}${paths.join('/')}` : '/';
    }
};

export const getLocationRef = (redireccion): string => {
    let hostname = '/portal-servicios/';
    try {
        hostname = '/';
    } catch (error) {
        console.error(error);
    }
    redireccion = redireccion ?? '/';
    if (
        redireccion?.includes('https') ||
        redireccion?.includes('http') ||
        redireccion?.includes('www')
    ) {
        return redireccion;
    } else {
        const paths = redireccion?.split('/');
        if (
            paths &&
            (paths[0].includes('portal-servicios') || paths[0] === '')
        ) {
            paths.shift();
        }
        // console.log("changeRef", redireccion, paths)
        return paths ? `${hostname}${paths.join('/')}` : '/';
    }
};

export const getTarget = (redireccion) => {
    return redireccion?.includes('https') ||
        redireccion?.includes('http') ||
        redireccion?.includes('www')
        ? '_blank'
        : '_self';
};

export const isUrlHttp = (url: string) => {
    return (
        url?.includes('https') || url?.includes('http') || url?.includes('www')
    );
};
